"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
var reactstrap_1 = require("reactstrap");
var kendo_react_dateinputs_1 = require("@progress/kendo-react-dateinputs");
var serialize = function (obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
};
var datePickerStyle = "\n    .k-animation-container {\n    z-index: 10003 ;\n}\n@media (min-width: 576px){\n.modal-dialog {\n    max-width: 700px;\n    margin: 1.75rem auto;\n}}\n";
var ProgramRequest = /** @class */ (function (_super) {
    __extends(ProgramRequest, _super);
    function ProgramRequest(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            ddlState: [],
            ddlProgramType: [],
            ddlProgramTime: [],
            FName: '',
            LName: '',
            Address1: '',
            Address2: '',
            City: '',
            State: '',
            Zipcode: '',
            Email: '',
            PhoneNumber: '',
            ProgramType: '',
            ProgramTime: '',
            PreferedDate1: new Date(new Date().setDate(new Date().getDate() + 45)),
            PreferedTime1: new Date(),
            PreferedDate2: new Date(new Date().setDate(new Date().getDate() + 45)),
            PreferedTime2: new Date(),
            PreferedDate3: new Date(new Date().setDate(new Date().getDate() + 45)),
            PreferedTime3: new Date(),
            lblResult: ''
        };
        fetch('api/ListItems/State')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddlState: list });
        }).catch(function (error) {
            console.log(error);
        });
        fetch('api/ListItems/RegistrantType')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddlProgramType: list });
        }).catch(function (error) {
            console.log(error);
        });
        fetch('api/ListItems/MeetingSource')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddlProgramTime: list });
        }).catch(function (error) {
            console.log(error);
        });
        _this.RequestProgram = _this.RequestProgram.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.validate = _this.validate.bind(_this);
        _this.Clear = _this.Clear.bind(_this);
        return _this;
    }
    ;
    ProgramRequest.prototype.componentDidMount = function () {
        //Zipcode
        var senderZipcode = document.getElementById("senderZipcode");
        if (senderZipcode != null) {
            var attZipcode = document.createAttribute("inputmode");
            attZipcode.value = "numeric";
            senderZipcode.setAttributeNode(attZipcode);
        }
        //Phone
        var varPhone = document.getElementById("mtPhone");
        if (varPhone != null) {
            var attPhone = document.createAttribute("inputmode");
            attPhone.value = "numeric";
            varPhone.setAttributeNode(attPhone);
        }
    };
    ProgramRequest.prototype.RequestProgram = function () {
        var _this = this;
        if (!this.validate())
            return;
        var logObj = this.state.FName + "|" + this.state.LName + "|" + this.state.Address1 + "|" + this.state.Address2 + "|" + this.state.City + "|" + this.state.State + "|" + this.state.Zipcode + "|" + this.state.Email + "|" + this.state.PhoneNumber + "|" + this.state.ProgramType + "|" + this.state.ProgramTime + "|" + this.state.PreferedDate1.toJSON() + "|" + this.state.PreferedTime1.toJSON() + "|" + this.state.PreferedDate2.toJSON() + "|" + this.state.PreferedTime2.toJSON() + "|" + this.state.PreferedDate3.toJSON() + "|" + this.state.PreferedTime3.toJSON();
        var queryStr = serialize({ sProgramRequestDetails: logObj });
        var base_url = 'api/Registration/SendProgramRequestEmail';
        var init = { method: 'GET', accept: 'application/json', headers: {} };
        fetch(base_url + "?" + queryStr, init).then(function (response) { return response.json(); })
            .then(function (result) {
            if (result == true) {
                _this.props.onProgramRequestFormClose(false);
                _this.props.onSubmit(true);
                _this.Clear();
            }
            else {
                _this.setState({ lblResult: "Something went wrong. Email not sent successfully." });
            }
        });
    };
    ProgramRequest.prototype.handleCancel = function (e) {
        this.props.onProgramRequestFormClose(false);
    };
    ProgramRequest.prototype.validate = function () {
        var fname = this.state.FName;
        var lname = this.state.LName;
        var address1 = this.state.Address1;
        var city = this.state.City;
        var state = this.state.State;
        var zipcode = this.state.Zipcode;
        var email = this.state.Email;
        var phone = this.state.PhoneNumber;
        var programType = this.state.ProgramType;
        var programTime = this.state.ProgramTime;
        var preferedDate1 = this.state.PreferedDate1;
        var preferedTime1 = this.state.PreferedTime1;
        var preferedDate2 = this.state.PreferedDate2;
        var preferedTime2 = this.state.PreferedTime2;
        var preferedDate3 = this.state.PreferedDate3;
        var preferedTime3 = this.state.PreferedTime3;
        if (fname === '' || lname === '' || address1 === '' || address1 === '' || city === '' || state === '' || zipcode === '' || email === '' || phone === '' || programType === '' || programTime === '' || preferedDate1 === null || preferedTime1 === null || preferedDate2 === null || preferedTime2 === null || preferedDate3 === null || preferedTime3 === null) {
            this.setState({ lblResult: "Please enter all the required fields." });
            return false;
        }
        if (email !== '' && !this.validateEmail(email)) {
            this.setState({ lblResult: email + " is not valid email. Please enter valid email." });
            return false;
        }
        if (!this.validateZIP(zipcode)) {
            this.setState({ lblResult: zipcode + " is not valid ZIP Code. Please enter valid zipcode." });
            return false;
        }
        if (!this.validatePhone(phone)) {
            this.setState({ lblResult: phone + " is not valid Phone Number. Please enter valid phone number." });
            return false;
        }
        return true;
    };
    ProgramRequest.prototype.validateEmail = function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
    ProgramRequest.prototype.validateZIP = function (ZIP) {
        var re = /^((\d{5}(-|\s)\d{0,4})|(\d{5}))$/;
        return re.test(ZIP);
    };
    ProgramRequest.prototype.validatePhone = function (phone) {
        var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        return re.test(phone);
    };
    ProgramRequest.prototype.Clear = function () {
        this.setState({ FName: '' });
        this.setState({ LName: '' });
        this.setState({ Address1: '' });
        this.setState({ Address2: '' });
        this.setState({ City: '' });
        this.setState({ State: '' });
        this.setState({ Zipcode: '' });
        this.setState({ Email: '' });
        this.setState({ PhoneNumber: '' });
        this.setState({ ProgramType: '' });
        this.setState({ ProgramTime: '' });
        this.setState({ PreferedDate1: '' });
        this.setState({ PreferedTime1: '' });
        this.setState({ PreferedDate2: '' });
        this.setState({ PreferedTime2: '' });
        this.setState({ PreferedDate3: '' });
        this.setState({ PreferedTime3: '' });
    };
    ProgramRequest.prototype.render = function () {
        var _this = this;
        var minDate = new Date(new Date().setDate(new Date().getDate() + 45));
        return (React.createElement(React.Fragment, null,
            React.createElement("style", null, datePickerStyle),
            React.createElement(reactstrap_1.Modal, { isOpen: true, className: "modal-content" },
                React.createElement(reactstrap_1.ModalHeader, { id: "AddTitle" }, "REQUEST A PROGRAM"),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("div", null,
                                React.createElement("strong", { style: { color: "black" } }, "Contact Information")))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { style: { color: "Red" } }, "*"),
                            React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "First Name:"),
                            React.createElement("input", { type: "text", name: "firstname", "aria-label": "firstname", className: "fieldcontrol2", value: this.state.FName, onChange: function (e) { _this.setState({ FName: e.target.value }); }, required: true })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { style: { color: "Red" } }, "*"),
                            React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Last Name:"),
                            React.createElement("input", { type: "text", name: "lastname", "aria-label": "lastname", className: "fieldcontrol2", value: this.state.LName, onChange: function (e) { _this.setState({ LName: e.target.value }); }, required: true }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "Address1:"),
                            React.createElement("input", { type: "text", name: "address1", "aria-label": "address1", className: "fieldcontrol2", value: this.state.Address1, onChange: function (e) { _this.setState({ Address1: e.target.value }); }, required: true })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "fieldlabel1" }, "Address2:"),
                            React.createElement("input", { type: "text", name: "address2", "aria-label": "address2", className: "fieldcontrol2", value: this.state.Address2, onChange: function (e) { {
                                    _this.setState({ Address2: e.target.value });
                                } } }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "City:"),
                            React.createElement("input", { type: "text", name: "city", "aria-label": "city", className: "fieldcontrol2", value: this.state.City, onChange: function (e) { {
                                    _this.setState({ City: e.target.value });
                                } }, required: true })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "State:"),
                            React.createElement("select", { "data-val": "true", name: "state", "aria-label": "state", className: "fieldcontrol2", value: this.state.State, onChange: function (e) { {
                                    _this.setState({ State: e.target.value });
                                } }, required: true }, this.state.ddlState.map(function (state) {
                                return React.createElement("option", { key: state.itemValue, value: state.itemValue }, state.itemText);
                            }))),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "Zip Code:"),
                            React.createElement("div", null,
                                React.createElement(kendo_react_inputs_1.MaskedTextBox, { mask: "#####", name: "zipcode", "aria-labelledby": "zipcode", key: "number", id: "recipientZipcode", value: this.state.Zipcode, onChange: function (e) { {
                                        _this.setState({ Zipcode: e.target.value });
                                    } }, required: true })))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { style: { color: "Red" } }, "*"),
                            React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Email:"),
                            React.createElement("input", { type: "email", name: "email", "aria-label": "email", value: this.state.Email, className: "fieldcontrol2", onChange: function (e) { _this.setState({ Email: e.target.value }); }, required: true })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "Phone Number:"),
                            React.createElement("div", null,
                                React.createElement(kendo_react_inputs_1.MaskedTextBox, { mask: "(###) ###-####", className: "fieldcontrol2", id: "mtPhone", name: "phone", "aria-labelledby": "phonenumber", value: this.state.PhoneNumber, onChange: function (e) { _this.setState({ PhoneNumber: e.target.value }); }, key: "number", required: true })))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("div", null,
                                React.createElement("strong", { style: { color: "black" } }, "Program Requests**")))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "Select Program Type"),
                            React.createElement("div", null,
                                React.createElement("select", { "data-val": "true", name: "programType", "aria-label": "programType", className: "fieldcontrol2", onChange: function (e) { {
                                        _this.setState({ ProgramType: e.target.value });
                                    } }, required: true },
                                    React.createElement("option", { value: "" }, "Select"),
                                    React.createElement("option", { value: "Live" }, "Live"),
                                    React.createElement("option", { value: "Virtual" }, "Virtual")))),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "Select Program Time of Day"),
                            React.createElement("div", null,
                                React.createElement("select", { "data-val": "true", name: "programTime", "aria-label": "programTime", className: "fieldcontrol2", onChange: function (e) { {
                                        _this.setState({ ProgramTime: e.target.value });
                                    } }, required: true },
                                    React.createElement("option", { value: "" }, "Select"),
                                    React.createElement("option", { value: "Lunch" }, "Lunch"),
                                    React.createElement("option", { value: "Dinner" }, "Dinner"))))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { style: { padding: "10px" } },
                            React.createElement("span", null, "Please provide dates that are 6 weeks out to allow for processing the request."))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "fieldlabel1" }, "Preferred Dates / Times"))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement(kendo_react_dateinputs_1.DatePicker, { name: "FromDate", format: "M/d/yyyy", className: "fieldcontrol2", min: minDate, defaultValue: this.state.PreferedDate1, onChange: function (e) { return _this.setState({ PreferedDate1: e.target.value }); } })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement(kendo_react_dateinputs_1.TimePicker, { width: "120px", defaultValue: this.state.PreferedTime1, onChange: function (e) { return _this.setState({ PreferedTime1: e.target.value }); } }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement(kendo_react_dateinputs_1.DatePicker, { name: "FromDate", format: "M/d/yyyy", className: "fieldcontrol2", min: minDate, defaultValue: this.state.PreferedDate2, onChange: function (e) { return _this.setState({ PreferedDate2: e.target.value }); } })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement(kendo_react_dateinputs_1.TimePicker, { width: "120px", defaultValue: this.state.PreferedTime2, onChange: function (e) { return _this.setState({ PreferedTime2: e.target.value }); } }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement(kendo_react_dateinputs_1.DatePicker, { name: "FromDate", format: "M/d/yyyy", className: "fieldcontrol2", min: minDate, defaultValue: this.state.PreferedDate3, onChange: function (e) { return _this.setState({ PreferedDate3: e.target.value }); } })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement(kendo_react_dateinputs_1.TimePicker, { width: "120px", defaultValue: this.state.PreferedTime3, onChange: function (e) { return _this.setState({ PreferedTime3: e.target.value }); } }))),
                    React.createElement("div", { className: "row", style: { fontFamily: "Open Sans,sans-serif", fontStyle: "13px" } },
                        React.createElement("br", null),
                        React.createElement("p", null, "By submitting this form, I certify that I am a US resident 18 years of age or older and agree to receiving further communications, including marketing communications, from BioCryst. By registering for the program, I agree that BioCryst (including its representatives and vendors) may use my personal information provided above for data analysis to determine if I am prescribed BioCryst products, to measure the effectiveness of the program, and to contact me for marketing purposes related to BioCryst products and services. I understand that any personally identifying information I provide will be used and protected in accordance with the Terms of Use and Privacy Policy."),
                        React.createElement("br", null),
                        React.createElement("div", { style: { textAlign: "center", padding: "10px", width: "100%" } },
                            React.createElement("span", { style: { fontStyle: "italic", textAlign: "center" } },
                                React.createElement("span", { className: "required" }, "*"),
                                "Required field (Enter N/A if not applicable)"))),
                    React.createElement("div", null,
                        React.createElement("span", { style: { color: "Red" } }, this.state.lblResult))),
                React.createElement(reactstrap_1.ModalFooter, { style: { display: "block" } },
                    React.createElement("div", { style: { textAlign: "center" } },
                        React.createElement("button", { className: "link-button6", onClick: this.RequestProgram }, "Submit"),
                        "\u00A0",
                        React.createElement("button", { className: "link-button6-grey", onClick: this.handleCancel }, "Cancel"))))));
    };
    return ProgramRequest;
}(React.PureComponent));
exports.default = ProgramRequest;
;
//# sourceMappingURL=ProgramRequest.js.map